// framework
import { immerable, produce } from "immer";
// api
import * as Client from "../../../../api/Client";
import { CallResultError } from "../../../../api/callHelper";

export interface IRootViewModel {
    readonly applicationId: string | undefined;
    readonly applicationTypeName: string | undefined;
    readonly titleType: string | undefined;
    readonly titleId: string | undefined;
    readonly titleNumber: string | undefined;
    readonly applicantCompany: string | undefined;
    readonly lodgedDate: Date | undefined;
    readonly implementedDate: Date | undefined;
    readonly applicationStatusName: string | undefined;
    readonly offshoreAreaName: string | undefined;
    readonly approvalTracking: Client.GetPublicApplicationsTrackingDetailsApprovalTrackingDto[];
    readonly isBusy: boolean;
    readonly error: CallResultError | undefined;

    applicationTrackingDetailsLoading(): IRootViewModel;
    applicationTrackingDetailsLoaded(response: Client.GetPublicOpggsApplicationsTrackingDetailsResponseDto | undefined, error: CallResultError | undefined): IRootViewModel;
}

export class RootViewModel implements IRootViewModel {
    [immerable] = true;

    constructor() {
        this.applicationId = undefined;
        this.approvalTracking = [];
        this.isBusy = false;
        this.error = undefined;
    }
    public readonly applicationId: string | undefined;
    public readonly applicationTypeName: string | undefined;
    public readonly titleType: string | undefined;
    public readonly titleId: string | undefined;
    public readonly titleNumber: string | undefined;
    public readonly applicantCompany: string | undefined;
    public readonly lodgedDate: Date | undefined;
    public readonly implementedDate: Date | undefined;
    public readonly applicationStatusName: string | undefined;
    public readonly offshoreAreaName: string | undefined;
    public readonly approvalTracking: Client.GetPublicApplicationsTrackingDetailsApprovalTrackingDto[];
    public readonly isBusy: boolean;
    public readonly error: CallResultError | undefined;

    public applicationTrackingDetailsLoading(): IRootViewModel {
        return produce(this, (draft) => {
            draft.isBusy = true;
        });
    }

    public applicationTrackingDetailsLoaded(response: Client.GetPublicOpggsApplicationsTrackingDetailsResponseDto | undefined, error: CallResultError | undefined): IRootViewModel {
        return produce(this, (draft) => {
            if (response) {
                draft.applicationId = response.applicationId;
                draft.applicationTypeName = response.applicationTypeName;
                draft.titleType = response.titleType;
                draft.titleId = response.titleId;
                draft.titleNumber = response.titleNumber;
                draft.applicantCompany = response.applicantCompany;
                draft.lodgedDate = response.lodgedDate;
                draft.implementedDate = response.implementedDate;
                draft.applicationStatusName = response.applicationStatusName;
                draft.offshoreAreaName = response.offshoreAreaName;
                draft.approvalTracking = response.approvalTracking ?? [];
            }
            draft.isBusy = false;
            draft.error = error;
        });
    }
}
